import React, {Component, createRef} from "react";
import DataTable from './TableBase';
import {withRouter} from "react-router-dom";
import mainHelper, {apiCall} from "../../helpers/MainHelper";
import Swal from "sweetalert2";
import withPermissions from "../WithPermissions";
import ReactDOMServer from "react-dom/server";
import ReactLoading from "react-loading";

class AppointmentsTable extends Component{

    constructor(props) {
        super(props);
        this.tableRef = createRef();
        this.state = {
            pending:true,
            loading:false,
        }

    }
    handleAppointmentDetail = (appointmentId) => {
        this.props.history.push(`${process.env.PUBLIC_URL}/appointments/${appointmentId}`);
    }
    triggerFetch = (page = 1, size = 10, search = '') => {
        if (this.tableRef.current) {
            this.tableRef.current.fetchData(page, size, search);
        }
    };

    handleApprove = async (appointmentId) => {
        // Şubeler yüklenirken loader göster
        Swal.fire({
            title: 'Şubeler yükleniyor...',
            text: 'Lütfen bekleyin',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            // Şubeleri çek
            const branches = await this.getBranches();

            // Loader'ı kapat
            Swal.close();

            // Şube seçimi için modal aç
            const { value: branchId } = await Swal.fire({
                title: 'Şube Seçin',
                input: 'select',
                inputOptions: branches,
                inputPlaceholder: 'Şube seçin',
                showCancelButton: true,
                confirmButtonText: 'Onayla',
                cancelButtonText: 'İptal',
                inputValidator: (value) => {
                    if (!value) {
                        return 'Lütfen bir şube seçin';
                    }
                }
            });

            if (!branchId) {
                return;
            }

            // Servis notu için input
            const { value: serviceNotes } = await Swal.fire({
                title: 'Servis Notu (Opsiyonel)',
                input: 'textarea',
                inputPlaceholder: 'Servis notu giriniz...',
                showCancelButton: true,
                confirmButtonText: 'Onayla',
                cancelButtonText: 'İptal',
                inputAttributes: {
                    'aria-label': 'Servis notu'
                },
                allowOutsideClick: false
            });

            const result = await Swal.fire({
                title: 'Randevuyu onaylamak istediğinize emin misiniz?',
                text: "Bu işlem araç kaydını servise atayacak ve servis kaydı oluşturacak.",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Evet, onayla!',
                cancelButtonText: 'Hayır, iptal et',
                preConfirm: async () => {
                    const confirmButton = Swal.getConfirmButton();
                    const originalButtonText = confirmButton.innerHTML;
                    confirmButton.disabled = true;
                    confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

                    try {
                        await apiCall(`business/appointment/${appointmentId}/approve`, 'post', {
                            branch_id: branchId,
                            service_notes: serviceNotes || ''
                        });
                        await this.triggerFetch();
                        return true;
                    } catch (error) {
                        return false;
                    } finally {
                        confirmButton.innerHTML = originalButtonText;
                        confirmButton.disabled = false;
                    }
                }
            });

            if (result.isConfirmed) {
                if (result.value) {
                    Swal.fire(
                        'Onaylandı!',
                        'Randevu onaylandı ve servis kaydı oluşturuldu.',
                        'success'
                    );
                } else {
                    Swal.fire(
                        'Hata!',
                        'Randevu onaylanırken bir hata oluştu.',
                        'error'
                    );
                }
            }
        } catch (error) {
            // Hata durumunda loader'ı kapat
            Swal.close();
            Swal.fire({
                title: 'Hata!',
                text: 'Şubeler yüklenirken bir hata oluştu. Lütfen tekrar deneyin.',
                icon: 'error',
                confirmButtonText: 'Tamam'
            });
            return;
        }
    }

    handleReject = async (appointmentId) => {
        const { value: rejectionReason } = await Swal.fire({
            title: 'Red Nedeni',
            input: 'textarea',
            inputPlaceholder: 'Red nedeni giriniz...',
            showCancelButton: true,
            confirmButtonText: 'Reddet',
            cancelButtonText: 'İptal',
            inputValidator: (value) => {
                if (!value || value.trim().length === 0) {
                    return 'Lütfen red nedeni giriniz';
                }
            },
            allowOutsideClick: false
        });

        if (!rejectionReason) {
            return;
        }

        const result = await Swal.fire({
            title: 'Randevuyu reddetmek istediğinize emin misiniz?',
            text: "Bu işlem geri alınamaz!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Evet, reddet!',
            cancelButtonText: 'Hayır, iptal et',
            preConfirm: async () => {
                const confirmButton = Swal.getConfirmButton();
                const originalButtonText = confirmButton.innerHTML;
                confirmButton.disabled = true;
                confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

                try {
                    await apiCall(`business/appointment/${appointmentId}/reject`, 'post', {
                        rejection_reason: rejectionReason
                    });
                    await this.triggerFetch();
                    return true;
                } catch (error) {
                    return false;
                } finally {
                    confirmButton.innerHTML = originalButtonText;
                    confirmButton.disabled = false;
                }
            }
        });

        if (result.isConfirmed) {
            if (result.value) {
                Swal.fire(
                    'Reddedildi!',
                    'Randevu reddedildi.',
                    'success'
                );
            } else {
                Swal.fire(
                    'Hata!',
                    'Randevu reddedilirken bir hata oluştu.',
                    'error'
                );
            }
        }
    }

    getBranches = async () => {
        try {
            const response = await apiCall('business/branch/get-branches-for-select', 'get', null);
            const branches = {};
            if (response && Array.isArray(response)) {
                response.forEach(branch => {
                    branches[branch.id] = branch.name;
                });
            } else if (response && response.data && Array.isArray(response.data)) {
                response.data.forEach(branch => {
                    branches[branch.id] = branch.name;
                });
            }
            return branches;
        } catch (error) {
            Swal.fire('Hata', 'Şubeler yüklenirken bir hata oluştu', 'error');
            return {};
        }
    }

    getStatusBadge = (status) => {
        const statusMap = {
            'pending': { text: 'Beklemede', class: 'badge-warning' },
            'approved': { text: 'Onaylandı', class: 'badge-success' },
            'rejected': { text: 'Reddedildi', class: 'badge-danger' },
            'cancelled': { text: 'İptal Edildi', class: 'badge-secondary' },
            'completed': { text: 'Tamamlandı', class: 'badge-info' }
        };
        const statusInfo = statusMap[status] || { text: status, class: 'badge-secondary' };
        return `<span class="badge ${statusInfo.class}">${statusInfo.text}</span>`;
    }

    render() {
        const {pending} = this.state;
        const {userPermissions} = this.props;
        const userHasViewAppointmentPermission = userPermissions.includes('view appointment');
        const userHasApproveAppointmentPermission = userPermissions.includes('approve appointment');
        const columns = [
            {
                name:'Randevu No',
                selector:row => row.id,
                sortable:true
            },
            {
                name:'Plaka',
                selector:row => row.vehicle?.plate?.toUpperCase() || '-',
                sortable:true
            },
            {
                name:'Marka/Model',
                selector:row => {
                    const brand = row.vehicle?.brand?.name || '';
                    const model = row.vehicle?.model?.name || '';
                    return `${brand} ${model}`.trim() || '-';
                },
            },
            {
                name:'Müşteri',
                selector:row => {
                    const name = row.vehicle?.customer?.name?.toUpperCase() || '';
                    const surname = row.vehicle?.customer?.surname?.toUpperCase() || '';
                    return `${name} ${surname}`.trim() || '-';
                },
            },
            {
                name:'Randevu Tarihi',
                selector:row => {
                    const dateStr = mainHelper.dateOnlyFormat(row.appointment_date);
                    const timeStr = row.appointment_time || '';
                    return dateStr && timeStr ? `${dateStr} ${timeStr}` : dateStr || timeStr || '-';
                },
                sortable:true
            },
            {
                name:'Durum',
                cell: row => (
                    <span dangerouslySetInnerHTML={{ __html: this.getStatusBadge(row.status) }} />
                ),
                sortable:true
            },
            {
                name:'Acil',
                selector:row => row.is_emergency ? 'Evet' : 'Hayır',
                sortable:true
            },

        ]
        return (
            <DataTable
                ref={this.tableRef}
                dataEndpoint={this.props.dataEndpoint || "business/appointment/all"}
                extraQueryParams={this.props.extraQueryParams || {}}
                columns={columns}
                onRowClicked={userHasViewAppointmentPermission ? row => this.handleAppointmentDetail(row.id) : undefined}
                progressPending={pending}>
            </DataTable>
        )
    }

}
export default withPermissions(withRouter(AppointmentsTable));
